module.exports = __webpack_public_path__ + "c867ee7d6fe3460d23cc12f28eda25b4.svg";